export default {"src":"/_next/static/media/LearningGoals.0d4b9ba2.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};